import React from "react"
import { mapColumnSize } from "src/legacy/utils"

import { Element } from "legacy/components/shared/base"
import { SectionTitleType } from "types/shared-components"
import { Maybe } from "types/Maybe"
import { Title } from "legacy/components/Redesign/Title/Title"

export type SectionTitleProps = {
  data: Maybe<SectionTitleType>
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  data,
}): React.ReactElement<SectionTitleProps> | null => {
  const { primary } = data

  const { section_title, title_alignment, title_size, title_width } = primary
  const title = section_title?.text

  if (!primary && !title) {
    return null
  }

  const mobileColumnSize = mapColumnSize(12)
  const columnSize = mapColumnSize(title_width)

  return (
    <Element gridTemplateColumns="repeat(12, 1fr)">
      <Title
        gridColumnEnd={[
          mobileColumnSize.gridColumnEnd,
          columnSize.gridColumnEnd,
        ]}
        gridColumnStart={[
          mobileColumnSize.gridColumnStart,
          columnSize.gridColumnStart,
        ]}
        maxWidth="contentWidth"
        mb="lg"
        mt={["lg", "xxlg"]}
        mx="auto"
        textAlign={title_alignment === "Left" ? "left" : "center"}
        title={title}
        titleSize={title_size}
      />
    </Element>
  )
}
